import axios from '@/plugins/axios'

const getBanks = async () => {
  try {
    const response = await axios.get('banks')
    const { data } = response
    return data
  } catch (error) {
    return Promise.reject(error)
  }
}

const getBankAccounts = async () => {
  try {
    const response = await axios.get('bank-accounts')
    const { data } = response
    return data
  } catch (error) {
    return Promise.reject(error)
  }
}

const getPrimaryBankAccount = async () => {
  try {
    const accounts = await getBankAccounts()
    return accounts.find(ac => ac.is_primary)
  } catch (error) {
    return Promise.reject(error)
  }
}

const create = async ({
  bank,
  agency,
  // eslint-disable-next-line camelcase
  agency_digit,
  account,
  digit,
  type,
  // eslint-disable-next-line camelcase
  owner_name,
  // eslint-disable-next-line camelcase
  owner_document,
  // eslint-disable-next-line camelcase
  owner_document_type
}) => {
  try {
    const params = {
      bank: bank,
      agency: agency,
      account: account,
      digit: digit,
      type: type,
      owner_name: owner_name,
      owner_document: owner_document,
      owner_document_type: owner_document_type
    }

    // eslint-disable-next-line camelcase
    if (agency_digit) params.agency_digit = agency_digit

    const response = await axios.post('bank-accounts', params)
    const { data } = response
    return data
  } catch (error) {
    return Promise.reject(error)
  }
}

const destroy = async (id) => {
  try {
    const response = await axios.post(`bank-accounts/${id}`, {
      _method: 'DELETE'
    })

    const { data } = response
    return data
  } catch (error) {
    return Promise.reject(error)
  }
}

const turnPrimary = async (id) => {
  try {
    const response = await axios.post(`bank-accounts/${id}/primary`, {
      _method: 'PUT'
    })
    const { data } = response
    return data
  } catch (error) {
    return Promise.reject(error)
  }
}

export default {
  create,
  destroy,
  getBanks,
  getBankAccounts,
  getPrimaryBankAccount,
  turnPrimary
}
